import { rd } from '@passionware/monads';
import { RESOURCE_CORE_FIELD_ICONS } from 'v5/patterns/resource/resourceFieldIcons';
import { ListBoxItemContent } from 'v5/design-system/ListBox';
import { FilterStringConfig } from 'v5/patterns/filters/FilterWidget.types';
import { myGeolocationService } from 'v5/services/io/GeolocationService/GeolocationService.connected';

export function createLocationsFilterConfig(): FilterStringConfig {
  return {
    label: 'Locations',
    icon: <RESOURCE_CORE_FIELD_ICONS.locations />,
    type: 'string',
    createDefaultValue: () => ({ operator: 'contains', value: '' }),
    options: {
      useSuggestions: search =>
        rd.useLastWithPlaceholder(
          rd.map(myGeolocationService.useLocations(search), items =>
            items.map(item => ({
              label: (
                <ListBoxItemContent
                  showCheckmark={false}
                  primary={item.name}
                  secondary={item.description}
                />
              ),
              value: item.name
            }))
          )
        )
    }
  };
}
